import { subscriptionErrorTypes } from './constants';
import { SUBSCRIPTION_FAILED } from './types';

const initialState = {
  error: false,
  errorType: null
};

const subscriptionPostCheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_FAILED:
      return {
        ...state,
        error: true,
        errorType: action.payload || subscriptionErrorTypes.subscription_failed
      };
    default:
      return state;
  }
};

export default subscriptionPostCheckoutReducer;
